module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_07-b4ab3ac24c988d17e9bcadc359a2c68f.svg";